import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { PopoverController } from "@ionic/angular";
import * as _ from "lodash";
import { ChangeQuantityInputPopoverComponent } from "./change-quantity-input-popover/change-quantity-input-popover.component";

@Component({
  selector: "app-change-quantity-input",
  templateUrl: "./change-quantity-input.component.html",
  styleUrls: ["./change-quantity-input.component.scss"],
})
export class ChangeQuantityInputComponent implements OnInit {
  public roundQuantity: any = 1;
  @Input() showIntegerQuantity;
  @Input() choiceStep: any;
  @Input() quantity;
  @Input() disableRemoveButton;
  @Input() disablePlusButton;
  @Input() hiddeQuntityComponent;
  @Input() buttonsSize;
  @Input() textSizeMedium;
  @Input() quantityInChoicesKind: any;
  @Output() changingQuantity = new EventEmitter();

  constructor(private popoverController: PopoverController) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes &&
      changes.quantity &&
      changes.quantity.previousValue !== changes.quantity.currentValue &&
      changes.quantity.previousValue &&
      this.showIntegerQuantity
    ) {
      this.roundQuantity = this.roundUp(
        _.cloneDeep(changes.quantity.currentValue)
      );
    }
  }
  ngOnInit() {
    if (this.quantity && this.showIntegerQuantity) {
      this.roundQuantity = this.roundUp(_.cloneDeep(this.quantity));
    }
  }

  roundUp(quantity) {
    if (quantity) {
      // console.log(
      //   "qqqqqq",
      //   this.choiceStep,
      //   quantity,

      //   parseFloat(quantity.toString()) / parseFloat(this.choiceStep.toString())
      // );
      return Math.round(
        parseFloat(quantity.toString()) / parseFloat(this.choiceStep.toString())
      );
    }
  }

  async openInputPopup(ev: any) {
    const popover = await this.popoverController.create({
      component: ChangeQuantityInputPopoverComponent,
      cssClass: "changeQuantityPopover",
      event: ev,
      backdropDismiss: false,
      translucent: true,
      componentProps: {
        quantityValue: _.cloneDeep(this.quantity),
        choiceStep: _.cloneDeep(this.choiceStep),
      },
    });

    await popover.present();

    await popover.onDidDismiss().then((data) => {
      if (data && data.data && !_.isNaN(data.data)) {
        this.changingQuantity.emit({
          role: "quantity_value",
          value: data.data,
        });
      }
    });
  }

  QuantityDecrease() {
    this.changingQuantity.emit({
      role: "decrease",
      value: null,
    });
  }

  QuantityIncrease() {
    this.changingQuantity.emit({
      role: "increase",
      value: null,
    });
  }
}
